import React, { useEffect, useState } from "react";
import { Button, Collapse } from "react-bootstrap";
import moment from "moment";
import { setStepIndex } from "../../../redux/globalJoyrideSlice";
import { useDispatch } from "react-redux";

const CompetitionCategoryTabs = ({
  categories,
  onBulkSubmit,
  onSelect,
  userData,
  selected,
  setSelected
}) => {
  const [openCategories, setOpenCategories] = useState({});
  const [editRows, setEditRows] = useState({});
  const [isValidEdit, setIsValidEdit] = useState(true);
  const dispatch = useDispatch();

  useEffect(() => {
    let allValid = true;
    for (const id in editRows) {
      const rowData = editRows[id];
      if (rowData.start_date && rowData.end_date) {
        const startDate = moment(rowData.start_date);
        const endDate = moment(rowData.end_date);
        if (startDate.isAfter(endDate)) {
          allValid = false;
          break;
        }
      }
    }
    setIsValidEdit(allValid);
  }, [editRows]);

  const toggleCategory = (cat) => {
    setOpenCategories((prev) => ({ ...prev, [cat]: !prev[cat] }));
    setTimeout(() => {
      dispatch(setStepIndex(2));
    }, 300);
  }

  const toggleCheckbox = (comp) => {
    const exists = selected.find((c) => c.id === comp.id);

    // 🚫 If already selected → show alert and stop
    if (exists) {
      alert("This competition is already added and cannot be changed.");
      return;
    }

    // ✅ Otherwise allow selection
    setSelected((prev) => [...prev, comp]);

    dispatch(setStepIndex(3));
  };


  const updateField = (id, field, value) => {
    setEditRows((prev) => ({
      ...prev,
      [id]: { ...prev[id], [field]: value },
    }));
  };

  return (
    <div data-tour="competition-category-list">
      {Object.entries(categories).map(([cat, comps]) => (
        <div key={cat} className="mb-3">
          <Button
            variant="outline-primary"
            onClick={() => toggleCategory(cat)}
            className="w-100 text-start"
          >
            {cat.toUpperCase()} ({comps.length})
          </Button>
          <div data-tour="competition-select-checkbox"></div>
          <Collapse in={!!openCategories[cat]}>
            <div className="mt-2">
              {comps.map((comp) => {
                const selectedComp = selected.find((c) => c.id === comp.id);
                const editing = editRows[comp.id] || null;
                const row = editing || comp;
                return (
                  <div key={comp.id} className="list-group-item">
                    <div className="d-flex align-items-center mb-2">
                      {userData?.roles === "user" ? (
                        <span
                          className="me-2"
                          style={{ fontSize: "20px", lineHeight: "20px" }}
                        >
                          •
                        </span>
                      ) : (
                        <input
                          type="checkbox"
                          checked={!!selectedComp}
                          onChange={() => toggleCheckbox(comp)}
                          className="me-2"
                        />
                      )}
                      <div className="flex-grow-1">
                        <strong>{row.name || row.details}</strong>
                        <span className="badge bg-primary ms-2">
                          {row.start_date
                            ? moment(row.start_date).format("MMM DD (ddd)")
                            : ""}
                          {row.start_date !== row.end_date &&
                            row.end_date &&
                            ` - ${moment(row.end_date).format("MMM DD (ddd)")}`}
                        </span>
                      </div>
                      {userData?.roles !== "user" && (
                        <button
                          className="btn btn-sm btn-warning ms-2"
                          onClick={() =>
                            setEditRows((prev) =>
                              prev[comp.id]
                                ? { ...prev, [comp.id]: undefined }
                                : { ...prev, [comp.id]: comp }
                            )
                          }
                        >
                          {editing ? "Cancel" : "Edit"}
                        </button>
                      )}
                      {/* <button className="btn btn-sm btn-info ms-2" onClick={() => onSelect(comp)}>
                        Use Form
                      </button> */}
                    </div>
                    {editing && (
                      <div className="row gx-2 gy-1">
                        <div className="col-md-3">
                          <input
                            type="text"
                            className="form-control"
                            value={row.name}
                            onChange={(e) =>
                              updateField(comp.id, "name", e.target.value)
                            }
                          />
                        </div>
                        <div className="col-md-3">
                          <input
                            type="date"
                            className="form-control"
                            value={moment(row.start_date).format("YYYY-MM-DD")}
                            onChange={(e) =>
                              updateField(comp.id, "start_date", e.target.value)
                            }
                          />
                        </div>
                        <div className="col-md-3">
                          <input
                            type="date"
                            className="form-control"
                            value={moment(row.end_date).format("YYYY-MM-DD")}
                            onChange={(e) =>
                              updateField(comp.id, "end_date", e.target.value)
                            }
                          />
                        </div>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </Collapse>
        </div>
      ))}
      {selected.length > 0 && (
        <div className="text-end mt-3">
          <button
            className="btn btn-success"
            data-tour="competition-submit-button"
            onClick={() => {
              if (!isValidEdit) {
                alert(
                  "Error: The start date cannot be after the end date. Please correct the dates before submitting."
                );
                return;
              }
              const mergedSelected = selected.map((item) => ({
                ...item,
                ...(editRows[item.id] || {}),
              }));
              onBulkSubmit(mergedSelected);
            }}
          >
            Submit Selected Competitions
          </button>
        </div>
      )}
    </div>
  );
};

export default CompetitionCategoryTabs;
